import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.find";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.function.name";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { callbackSwitchConfigManageAdd, callbackSwitchConfigManageUpd } from "@/api/financial/backhaul";
import { serchSelect, tabulation } from "@/mixins/index";
export default {
  mixins: [serchSelect],
  props: {
    productLists: {
      type: Array,
      data: function data() {
        return '';
      }
    },
    advertChannelData: {
      type: Array,
      data: function data() {
        return '';
      }
    }
  },
  data: function data() {
    return {
      dialogFormVisible: false,
      formData: {
        id: "",
        custom_name: "",
        product_id: '',
        advert_channel_id: '',
        params: []
      },
      isDisabled: false,
      rules: {
        custom_name: [{
          required: true,
          message: "请输入",
          trigger: "blur"
        }],
        product_id: [{
          required: true,
          message: "请选择产品",
          trigger: "blur"
        }],
        params: [{
          required: true,
          message: "请添加参数",
          trigger: "blur"
        }],
        advert_channel_id: [{
          required: true,
          message: "请选择",
          trigger: "blur"
        }],
        value: [{
          required: true,
          message: "请输入参数",
          trigger: "blur"
        }]
      }
    };
  },
  created: function created() {},
  methods: {
    init: function init(row) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var data, params, k, j;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.dialogFormVisible = true;

                if (row) {
                  data = _objectSpread({}, row);
                  params = data.params ? JSON.parse(data.params) : [];
                  data.params = [];

                  for (k in _this.formData) {
                    _this.formData[k] = data[k];
                  }

                  for (j in params) {
                    _this.formData.params.push({
                      name: j,
                      value: params[j]
                    });
                  }
                } else {
                  if (Array.isArray(_this.searchData.special_product_id)) {
                    _this.isDisabled = false;
                  } else {
                    _this.isDisabled = true;
                    _this.formData.product_id = _this.productLists.filter(function (item) {
                      return item.id == _this.searchData.special_product_id;
                    })[0].id;
                  }
                }

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    addContent: function addContent() {
      this.formData.params.push({
        name: '',
        value: ''
      });
    },
    removeContent: function removeContent(item) {
      var index = this.formData.params.indexOf(item);

      if (index !== -1) {
        this.formData.params.splice(index, 1);
      }
    },
    resetForm: function resetForm(formName) {
      this.dialogFormVisible = false;
      this.formData.id = '';
      this.clearData();
    },
    channelChange: function channelChange(e) {
      var _this2 = this;

      var data = this.advertChannelData.find(function (i) {
        return i.id == e;
      });
      this.formData.params = [];
      data.params = Array.isArray(data.params) ? data.params : JSON.parse(data.params);
      data.params.forEach(function (i) {
        _this2.formData.params.push({
          name: i,
          value: ''
        });
      });
    },
    dataFormSubmit: function dataFormSubmit(formName) {
      var _this3 = this;

      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          var data = _objectSpread({}, _this3.formData);

          var exdata = {};
          data.params.forEach(function (i) {
            exdata[i.name] = i.value;
          });
          data.params = exdata;
          var req = _this3.formData.id ? callbackSwitchConfigManageUpd : callbackSwitchConfigManageAdd;
          req(data).then(function (res) {
            if (res.status == 200) {
              _this3.$Message.success('操作成功');

              _this3.$emit("refreshDataList");

              _this3.resetForm("ruleForm");
            }
          });
        }
      });
    },
    clearData: function clearData() {
      this.formData = {
        id: this.formData.id,
        custom_name: "",
        product_id: '',
        advert_channel_id: '',
        params: []
      };
      this.$refs.ruleForm.resetFields();
    }
  }
};